export const rejectionReasons = [
  {
    id: 1,
    name: 'Incorrect Bank Account Details',
  },
  {
    id: 2,
    name: 'Insufficient Proof',
  },
  {
    id: 3,
    name: 'Incorrect Amount',
  },
  { id: -1, name: 'Need To Raise New Request' },
];
